import styled from "@emotion/styled";
import { Text } from "@otrium/atoms";

const StyledFilters = styled.div`
  margin-bottom: 24px;
`;

const ItemText = styled(Text)<{ active?: boolean }>`
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  line-height: 1.5;
  letter-spacing: 0.4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  font-weight: ${({ active }) => (active ? 600 : 400)};
`;

export { StyledFilters, ItemText };
